import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
import { useCookies } from "react-cookie";
import { hotjar } from "react-hotjar";

import useEffectOnce from "../hook/useEffectOnce";
import { useMixpanel } from "../mixpanel";

const HOTJAR_VERSION = 6;

export const useTracking = () => {
  const mixpanel = useMixpanel();
  const router = useRouter();

  const [logMetricsEvents, setLogMetricsEvents, removeLogMetricsEvents] =
    useCookies(["log-metric-events"]);

  useEffectOnce(() => {
    if (window.location.search.includes("logEvents=1")) {
      setLogMetricsEvents("log-metric-events", "1");
    } else if (logMetricsEvents) {
      removeLogMetricsEvents("log-metric-events");
    }
  });

  useEffectOnce(() => {
    if (typeof process.env.NEXT_PUBLIC_HOTJAR_ID === "string") {
      hotjar.initialize(
        parseInt(process.env.NEXT_PUBLIC_HOTJAR_ID, 10),
        HOTJAR_VERSION
      );
    }
  });

  const getTrackingDispatcher = useCallback(
    (eventName: string, customProps?: Record<string, unknown>) => {
      // Пытаемся автоматически определить тип визы и applicationId из URL
      const pathname = router.asPath || router.pathname || "";
      let visaType: string | undefined;

      if (pathname.startsWith("/o1")) {
        visaType = "o1";
      } else if (pathname.startsWith("/gtv")) {
        visaType = "gtv";
      }

      const applicationIdParam = router.query?.applicationId;
      const applicationId =
        typeof applicationIdParam === "string" ? applicationIdParam : undefined;

      mixpanel?.track(eventName, {
        visaType,
        applicationId,
        ...(customProps || {}),
      });
      hotjar?.event(eventName);

      if (logMetricsEvents) {
        console.info(
          ...[
            `[Tracking event]: %c${eventName}`,
            "color:red",
            customProps,
          ].filter(Boolean)
        );
      }
    },
    [mixpanel, logMetricsEvents, router]
  );

  return useMemo(
    () => ({
      trackEvent: getTrackingDispatcher,
    }),
    [getTrackingDispatcher]
  );
};
